export const environment = {
  production: false,
  appVersion: require('../../package.json').version + '-uat',
  mainApiUrl: 'https://mportal-api-development.azurewebsites.net/api/v1.0/',
  signalRUrl: 'https://memberportalfunctions-development.azurewebsites.net/api/negotiate',
  secureMailUrl: "https://secure-mail-api-development.azurewebsites.net/api/v1",
  defaultSlug: 'abc'
};
import 'zone.js/plugins/zone-error';
